export default {
  id: 'healthHistory/CHRONIC_CONDITIONS/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.chronicConditions',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.chronicConditions',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
